import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 640 640"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: ".4",
    d: ""
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M320.4 449.9L337.4 432.9L497.4 272.9L514.4 255.9L480.5 222L463.5 239L320.5 382L177.5 239L160.5 222L126.6 255.9L143.6 272.9L303.6 432.9L320.6 449.9z" })
], -1)
const _hoisted_2 = {
  key: 0,
  style: {"display":"contents"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["CategoryFilterSection", {'is-collapsed': _ctx.isCollapsed}])
  }, [
    _createElementVNode("h3", {
      class: "CategoryFilterSection-title",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.section.title) + " ", 1),
      (_ctx.selectedCount > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("(" + _toDisplayString(_ctx.selectedCount) + ")", 1)
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_1
    ]),
    (!_ctx.isCollapsed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "InputBase InputBase--small InputBase-my-5",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filter]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectionToRender, (control) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.controlType), {
              key: control.name ?? control.nameMin,
              data: control
            }, null, 8, ["data"]))
          }), 128)),
          (_ctx.controlType.name === 'FilterCheck')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.allVisible && _ctx.collectionToRender.length > _ctx.basicCountToRender)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "CategoryFilterSection-more",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleVisibility()))
                    }, " Zobrazit méně "))
                  : (_ctx.collection.length > _ctx.collectionToRender.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "CategoryFilterSection-more",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleVisibility()))
                      }, " Zobrazit více (" + _toDisplayString(_ctx.collection.length - _ctx.basicCountToRender) + ") ", 1))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}